"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    '@global': {
        ':root': {
            fontFamily: 'EuclidCircularB, "Helvetica Neue", Helvetica, Arial, sans-serif',
            backgroundColor: theme.grey9,
            position: 'fixed',
            zIndex: constants_1.HTMLROOT_FIXED_ZINDEX,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            overflow: 'hidden',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
            '-webkit-text-size-adjust': '100%'
        },
        body: {
            backgroundColor: 'inherit',
            margin: 0,
            height: '100%',
            width: '100%'
        },
        '#root': {
            backgroundColor: 'inherit',
            width: 'inherit',
            height: 'inherit'
        }
    }
});
//# sourceMappingURL=kanban.style.js.map